import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { GoogleLoginColouredIcon } from '@stepstone-genesis/icons';
import { useTranslation } from '@stepstone-platform/i18n';
import { googleAuthUrl } from '../../../../service/signIn/googleAuth.js';
import { useAppDispatch } from '../../../../hooks/redux/index.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { useAppSelector } from '../../../../hooks/redux/index.js';
import { isGoogleEnabledSelector, currentLocaleSelector, } from '../../../../core/siteConfig/siteConfigSlice.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../../../core/sourceData/sourceDataSlice.js';
import { trackButtonClick } from '../../../../tracking/index.js';
import { useCurrentUrl } from '../../../../hooks/useCurrentUrl.js';
import { rememberMeSelector } from '../../loginSlice.js';
import { selectNavigationContext } from '../../../../core/navigation/navigationSlice.js';
import { buildGoogleOverwritedRedirectionUrl } from '../../../../helpers/buildGoogleOverwritedRedirectionUrl.js';
export const LoginWithGoogle = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const loginSource = useAppSelector(loginSourceSelector);
    const currentLocale = useAppSelector(currentLocaleSelector);
    const currentUrl = useCurrentUrl();
    const checkboxState = useAppSelector(rememberMeSelector);
    const navigationContext = useAppSelector(selectNavigationContext);
    const overwritedRedirectionUrl = buildGoogleOverwritedRedirectionUrl(navigationContext, redirectionUrl, currentUrl);
    const onGoogleButtonClick = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'loginWithGoogle',
        }));
    };
    const isGoogleEnable = useAppSelector(isGoogleEnabledSelector);
    return isGoogleEnable ? (_jsx(Button, { "data-testid": "google-login-btn", as: "a", variant: "secondary", a11yLabel: "Login with google button", type: "button", href: googleAuthUrl({
            redirectionUrl: overwritedRedirectionUrl,
            loginSource,
            currentLocale,
            checkboxState,
            currentUrl,
            formType: 'login',
        }), isLoading: false, isFullWidth: true, iconBefore: _jsx(GoogleLoginColouredIcon, {}), size: ['medium'], onClick: onGoogleButtonClick, children: t('loginregistration.login.googleButton') })) : null;
};
//# sourceMappingURL=LoginWithGoogle.js.map